import styled from 'styled-components';

type globalCSSValues = 'inherit' | 'initial' | 'unset';

export type FlexDirection = 'row' | 'row-reverse' | 'column' | globalCSSValues;
export type FlexJustifyContent =
  | 'flex-start'
  | 'flex-end'
  | 'center'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | globalCSSValues;
export type FlexAlignItems =
  | 'flex-start'
  | 'flex-end'
  | 'center'
  | 'baseline'
  | 'stretch'
  | globalCSSValues;
export type FlexWrap = 'nowrap' | 'wrap' | 'wrap-reverse' | globalCSSValues;

export type FlexProps = {
  flex?: number | string | globalCSSValues;
  flexGrow?: number | globalCSSValues;
  flexShrink?: number | globalCSSValues;
  flexDirection?: FlexDirection;
  justifyContent?: FlexJustifyContent;
  alignItems?: FlexAlignItems;
  flexWrap?: FlexWrap;
  fullWidth?: boolean;
};

const Flex = styled.div<FlexProps>((props) => ({
  display: 'flex',
  flex: props.flex ?? 'initial',
  flexGrow: props.flexGrow ?? 'initial',
  flexShrink: props.flexShrink ?? 'initial',
  flexDirection: props.flexDirection ?? 'row',
  justifyContent: props.justifyContent ?? 'flex-start',
  alignItems: props.alignItems ?? 'stretch',
  flexWrap: props.flexWrap ?? 'nowrap',
  width: props.fullWidth ? '100%' : 'auto',
}));

export default Flex;
